import { render, staticRenderFns } from "./DeclarationDetailsList.vue?vue&type=template&id=08ac0a85"
import script from "./DeclarationDetailsList.vue?vue&type=script&lang=js"
export * from "./DeclarationDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports